export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive the package after purchasing?',
    a: "You'll receive instant access to all materials via email and online account. No waiting, no complicated steps. Start using it immediately.",
  },
  {
    q: 'What experience level do I need to use this?',
    a: "This is designed for teachers and instructors who already know drawing. You don't need to teach this material the way your classroom looks—adapt it to your style. The structure is there; you bring your experience.",
  },
  {
    q: 'Does this work for drawing teachers in any country?',
    a: 'Yes. The system covers universal drawing principles that work in any teaching context—academic, studio, private lessons, workshops, online teaching, community centers.',
  },
  {
    q: 'Can I edit and customize the material?',
    a: "Yes. You can edit, adapt, and customize the lessons to match your teaching style and your students' needs. The material is yours to use and modify.",
  },
  {
    q: 'What age groups does this cover?',
    a: 'The system is designed for students from approximately age 6 through adult. Each lesson includes Foundation, Developing, and Advanced level variations so you can teach the same skill to different levels.',
  },
  {
    q: 'What format is the material in?',
    a: 'Everything is delivered as PDF files. Digital format means instant access, searchable content, and you can print or use on screen—whatever works for you.',
  },
  {
    q: "What if the material doesn't work for me?",
    a: "You have 7 days to try everything. If it's not what you need, let us know and we'll refund your entire purchase. No questions, no hassle.",
  },
  {
    q: 'Will I get updates if the material changes?',
    a: 'You own the version you purchase. Any major updates will be available to you. We continuously improve the material based on teacher feedback.',
  },
]
